import { render, staticRenderFns } from "./TypoVibratingWireConfig.vue?vue&type=template&id=bd60eb5e&scoped=true&"
import script from "./TypoVibratingWireConfig.vue?vue&type=script&lang=js&"
export * from "./TypoVibratingWireConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd60eb5e",
  null
  
)

export default component.exports